import { createContext, useContext, useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const translations = {
  pt: {
    // Navigation
    nav: {
      home: "Início",
      passports: "Passaportes",
      howItWorks: "Como Funciona",
      how: "Como Funciona",
      experiences: "Atrações",
      attractions: "Atrações",
      prices: "Preços",
      partners: "Parceiros",
      about: "Sobre",
      faq: "FAQ",
      contact: "Contato",
      login: "Entrar",
      register: "Registar",
      dashboard: "Minha Conta",
      logout: "Sair"
    },
    // Hero
    hero: {
      tagline: "Lagos Special Edition",
      titleLine1: "O Passaporte para as",
      titleLine2: "Melhores Atrações",
      subtitle: "Descubra Lagos como nunca antes. 4 atrações exclusivas num único passaporte digital.",
      buyButton: "Comprar Passaporte",
      viewAttractions: "Ver Atrações",
      processing: "Processando..."
    },
    // Top Banner
    topBanner: {
      text: "Passaporte das Melhores Atrações do Algarve"
    },
    // How It Works
    howItWorks: {
      label: "Simples e Rápido",
      title: "Três passos e pronto",
      subtitle: "Não precisa imprimir nada. Tudo funciona no seu telemóvel.",
      step1Title: "Escolha o passaporte",
      step1Desc: "Compare os três níveis disponíveis e selecione o que melhor se adapta à sua viagem.",
      step2Title: "Receba no seu email",
      step2Desc: "Após a compra, receberá instantaneamente os seus QR Codes digitais no email.",
      step3Title: "Apresente nos locais",
      step3Desc: "Mostre o QR Code no seu telemóvel em cada parceiro. Simples e rápido.",
      startNow: "Começar Agora"
    },
    // How it works section
    how: {
      step1Title: "Escolha seu PASS",
      step1Desc: "Selecione o passaporte que combina com o seu estilo de viagem.",
      step2Title: "Receba seu QR Code",
      step2Desc: "Após a compra, recebe o QR Code na sua área de cliente.",
      step3Title: "Viva atrações",
      step3Desc: "Apresente seu QR Code nos parceiros e aproveite o melhor do Algarve."
    },
    // Sections
    sections: {
      howItWorks: "Como Funciona",
      passportTypes: "Tipos de Passaporte",
      featuredAttractions: "Atrações em Destaque",
      algarveMap: "Mapa do Algarve",
      officialPartners: "Nossos Parceiros Oficiais",
      faq: "Perguntas Frequentes"
    },
    // Categories
    categories: {
      all: "Todas",
      boat: "Passeios de Barco",
      gastro: "Gastronomia",
      sunset: "Sunset",
      adventure: "Aventura",
      family: "Família",
      relax: "Relaxamento"
    },
    // Offer / Countdown
    offer: {
      limitedTitle: "Oferta Limitada!",
      limitedDesc: "Garanta já o seu PASS Algarve e viva o melhor do Algarve.",
      buyNow: "Comprar Agora",
      days: "Dias",
      hours: "Horas",
      minutes: "Min",
      seconds: "Seg",
      joinTravelers: "Junte-se a mais de",
      travelersSatisfied: "5.630 turistas satisfeitos!",
      soonAttractions: "Atrações em breve",
      noPassports: "Nenhum passaporte disponível no momento."
    },
    // Attractions
    attractions: {
      label: "O que está incluído",
      title: "Atrações Inesquecíveis",
      duration: "Duração",
      highlights: "Destaques",
      viewMore: "Ver Mais",
      backToList: "Voltar",
      operatedBy: "Operado por",
      gallery: "Galeria",
      includedInPassports: "Passaportes que incluem esta atração",
      buyPassport: "Comprar Passaporte",
      noPassports: "Esta atração ainda não está incluída em nenhum passaporte.",
      from: "A partir de",
      perPerson: "/ pessoa",
      loading: "A carregar atração...",
      notFound: "Atração não encontrada",
      includedFree: "Incluído no PASS"
    },
    // Passports/Pricing
    passports: {
      title: "Passaporte Algarve",
      subtitle: "Escolha o passaporte ideal para si. Valide no seu telemóvel. Sem filas, sem complicações.",
      popular: "Mais Popular",
      validity: "Validade de",
      days: "dias",
      qrCode: "QR Code digital",
      support: "Suporte 24/7",
      includedAttractions: "Atrações incluídas:",
      chooseButton: "Escolher",
      perPerson: "/pessoa",
      youSave: "Poupe",
      bestseller: "Bestseller",
      loading: "Carregando passaportes..."
    },
    // About
    about: {
      label: "PASS Premium",
      title: "Passaporte Algarve | Portugal",
      description: "Compre em uma única compra as melhores atrações do Algarve. Sem filas, sem bilhetes avulsos, sem stress, só experiências qualificadas.",
      benefit1: "4 Atrações Premium Incluídas",
      benefit2: "Validade de 1 Ano",
      benefit3: "Passaporte Digital com QR Code",
      benefit4: "Adicione ao Apple Wallet",
      benefit5: "Acesso Prioritário nas Atrações",
      benefit6: "Suporte 24/7 em PT/EN",
      savingsTitle: "Poupe até 25% face a comprar separado",
      savingsSubtitle: "Em vez de pagar atração a atração, paga uma vez e desfruta sem preocupações.",
      pillar1Title: "Compre em 60 segundos",
      pillar1Desc: "Pagamento seguro via Stripe, receba o passaporte digital imediatamente no email.",
      pillar2Title: "100% seguro e flexível",
      pillar2Desc: "Pagamento encriptado, suporte rápido e validade alargada para usar quando quiser.",
      pillar3Title: "Atrações cuidadas",
      pillar3Desc: "Selecionámos as 4 melhores atrações de Lagos — testadas, premiadas e únicas.",
      includesLabel: "O que está incluído",
      cardTitle: "PASS ALGARVE",
      cardSubtitle: "Lagos Special Edition",
      cardRating: "4.9/5 (250+ avaliações)",
      perPerson: "/ pessoa",
      buyNow: "Comprar Agora",
      securePayment: "Pagamento seguro via Stripe",
      statSold: "Passaportes Vendidos",
      statRating: "Avaliação Média",
      statExperiences: "Atrações Premium"
    },
    // Testimonials
    testimonials: {
      label: "Testemunhos",
      title: "O Que Dizem Quem Já Usou",
      subtitle: "Mais de 10.000 viajantes já descobriram o Algarve com o nosso passaporte.",
      bought: "Comprou",
      review1: "Fizemos mais em 3 dias do que numa semana normal de férias. O QR Code funcionou perfeitamente em todos os locais. Recomendo totalmente!",
      review1Location: "Lisboa, Portugal",
      review1Product: "Passaporte Plus",
      review2: "O QR Code funcionou em todo o lado. Zero stress, sem filas para comprar bilhetes. As experiências gastronómicas incluídas foram o destaque da viagem.",
      review2Location: "Porto, Portugal",
      review2Product: "Passaporte Premium",
      review3: "Vale cada euro. Conseguimos visitar lugares que não conheceríamos de outra forma. O suporte foi excelente quando precisámos de ajuda.",
      review3Location: "Madrid, Espanha",
      review3Product: "Passaporte Essencial"
    },
    // FAQ
    faq: {
      label: "Ajuda",
      title: "Perguntas Frequentes",
      subtitle: "Tudo o que precisa saber sobre o Passaporte Algarve.",
      q1: "O passaporte tem data de validade?",
      a1: "Sim, o passaporte tem validade de 1 ano a partir da data de compra. Durante este período, pode utilizar todas as experiências incluídas.",
      q2: "Posso usar em mais do que um dia?",
      a2: "Sim! O passaporte permite utilizar as experiências em dias diferentes, desde que dentro do período de validade de 1 ano.",
      q3: "Como faço a reserva nos restaurantes?",
      a3: "Para o Happy Hour no Bon Vivant, basta apresentar o QR Code do seu passaporte. Recomendamos chegar com antecedência em época alta.",
      q4: "Há descontos para crianças?",
      a4: "Crianças até 3 anos não pagam. Entre 4-12 anos, consulte as condições específicas de cada experiência no momento da reserva.",
      q5: "Posso cancelar ou alterar?",
      a5: "O passaporte não é reembolsável após a compra, mas pode transferi-lo para outra pessoa. Contacte o suporte para mais informações.",
      q6: "O QR Code funciona offline?",
      a6: "Recomendamos ter conexão à internet para validação. Em caso de emergência, tire um screenshot do QR Code antes de ir à atração.",
      q7: "O que inclui cada nível de passaporte?",
      a7: "O Passaporte Lagos Special inclui 4 experiências: Ponta da Piedade, Gruta de Benagil, Observação de Golfinhos e Happy Hour no Bon Vivant.",
      q8: "Como contacto o suporte?",
      a8: "Pode contactar-nos por email em suporte@passaportealgarve.pt ou através do chat disponível no site. Respondemos em até 24 horas.",
      stillQuestions: "Ainda tem dúvidas?",
      contactUs: "Contacte-nos em"
    },
    // Footer
    footer: {
      description: "O seu passaporte digital para as melhores experiências de Lagos, Algarve. Descubra o melhor do sul de Portugal.",
      tagline: "Seu passaporte para as melhores experiências do Algarve. Válido por 1 ano.",
      quickLinks: "Links Rápidos",
      info: "Informações",
      contactUs: "Contato",
      newsletter: "Newsletter",
      newsletterDesc: "Receba ofertas exclusivas e novidades do Algarve.",
      emailPlaceholder: "Seu melhor e-mail",
      subscribe: "Inscrever-se",
      subscribeSuccess: "Inscrição registada! Em breve receberá novidades.",
      whatsappHours: "Atendimento via WhatsApp\nTodos os dias: 8h às 22h",
      builtWith: "Desenvolvido com",
      inAlgarve: "no Algarve",
      terms: "Termos e Condições",
      privacy: "Política de Privacidade",
      refund: "Política de Reembolso",
      cookies: "Cookies",
      contact: "Contacto",
      address: "Lagos, Algarve",
      country: "Portugal",
      securePayments: "Pagamentos seguros via",
      rights: "Todos os direitos reservados.",
      developedBy: "Desenvolvido por"
    },
    // Customer Dashboard
    dashboard: {
      title: "Minha Conta",
      welcome: "Bem-vindo",
      hello: "Olá",
      welcomePanel: "Bem-vindo ao seu painel PASS ALGARVE",
      myPassports: "Os Meus Passaportes",
      noPassports: "Ainda não comprou nenhum passaporte.",
      noPassportTitle: "Você ainda não tem passaporte",
      noPassportSubtitle: "Adquira seu PASS ALGARVE e comece a explorar Lagos!",
      buyPassportBtn: "Comprar Passaporte",
      buyNow: "Comprar Agora",
      purchaseDate: "Data de Compra",
      expiryDate: "Válido até",
      status: "Estado",
      active: "Ativo",
      expired: "Expirado",
      holder: "Titular",
      validity: "Validade",
      visits: "Visitas",
      tapForQR: "Toque para ver QR Code",
      showAtAttraction: "Apresente este código na atração",
      attractionsTitle: "Atrações",
      viewPassport: "Ver Passaporte",
      logout: "Sair",
      logoutSuccess: "Sessão encerrada com sucesso",
      home: "Início",
      loadError: "Erro ao carregar passaportes",
      checkoutError: "Erro ao iniciar checkout"
    },
    // Auth
    auth: {
      loginTitle: "Entrar",
      loginSubtitle: "Aceda à sua conta",
      registerTitle: "Criar Conta",
      registerSubtitle: "Registe-se para comprar o seu passaporte",
      email: "Email",
      password: "Palavra-passe",
      name: "Nome",
      loginButton: "Entrar",
      registerButton: "Registar",
      noAccount: "Não tem conta?",
      haveAccount: "Já tem conta?",
      register: "Registe-se",
      login: "Entre aqui",
      loginError: "Erro ao entrar. Verifique as suas credenciais.",
      registerError: "Erro ao registar. Tente novamente."
    },
    // Checkout
    checkout: {
      successTitle: "Pagamento Concluído!",
      successMessage: "Obrigado pela sua compra. O seu passaporte foi enviado para o seu email.",
      viewPassport: "Ver Passaporte",
      cancelTitle: "Pagamento Cancelado",
      cancelMessage: "O seu pagamento foi cancelado. Pode tentar novamente quando quiser.",
      backHome: "Voltar à Página Inicial"
    },
    // Common
    common: {
      loading: "Carregando...",
      error: "Erro",
      success: "Sucesso",
      processing: "Processando...",
      checkoutError: "Erro ao iniciar checkout. Tente novamente."
    },
    landing: {
      heroTitle1: "Explore o Algarve com",
      heroTitle2: "experiências exclusivas",
      heroTitle3: "em um único Passaporte.",
      heroSubtitle: "Acesso às melhores experiências, passeios e benefícios turísticos do Algarve com validade de 1 ano.",
      buyNow: "Comprar Agora",
      exploreAttractions: "Explorar Atrações",
      touristsUse: "viajantes já vivem o melhor do Algarve com mais praticidade e economia.",
      statPartners: "Parceiros Oficiais",
      statAttractions: "Atrações Incríveis",
      statTourists: "Turistas Satisfeitos",
      fromPrice: "A partir de",
      viewAllAttractions: "Ver todas as atrações",
      noAttractionsCategory: "Nenhuma atração disponível para esta categoria.",
      attractionFallbackDesc: "Atração imperdível no Algarve.",
      loadError: "Não foi possível carregar os passaportes. Verifique a sua ligação.",
      tryAgain: "Tentar novamente",
      exploreMap: "Explorar no Mapa Interativo",
      testimonialsTitle: "O que nossos turistas dizem",
      newsletterSuccess: "Inscrição registada! Obrigado.",
      newsletterInvalid: "Email inválido",
      checkoutError: "Erro ao iniciar checkout",
      t1: "O PASS Algarve tornou nossa viagem inesquecível! Super prático e experiências incríveis.",
      t1c: "Reino Unido",
      t2: "As melhores experiências do Algarve num só lugar. Economizamos e aproveitámos muito mais!",
      t2c: "França",
      t3: "Recomendo para todos que visitam o Algarve. Atendimento excelente e parceiros incríveis.",
      t3c: "Espanha",
      faqQ1: "O PASS Algarve é válido por quanto tempo?",
      faqA1: "Cada PASS Algarve tem validade de 1 ano completo a partir da data da compra. Use quando quiser dentro desse período.",
      faqQ2: "Como recebo meu QR Code?",
      faqA2: "Após o pagamento, recebe o QR Code instantaneamente por e-mail e fica disponível no seu painel de cliente.",
      faqQ3: "Posso cancelar meu PASS?",
      faqA3: "Sim. Cancelamento gratuito até 7 dias após a compra, desde que ainda não tenha utilizado nenhuma atração.",
      faqQ4: "Quantas experiências posso usar?",
      faqA4: "Depende do PASS escolhido. Cada tipo inclui um conjunto de experiências — todas listadas no detalhe do passaporte.",
      faqQ5: "O PASS é pessoal e intransferível?",
      faqA5: "Sim, o PASS está associado ao seu nome. Pode ser usado por si e pelos seus acompanhantes registados, conforme regras de cada experiência.",
      faqQ6: "Crianças têm desconto?",
      faqA6: "Sim. Crianças até 12 anos têm desconto especial em todos os passaportes Family. Entre em contacto para mais detalhes."
    },
    aboutPage: {
      home: "Início",
      breadcrumbAbout: "Sobre o PASS Algarve",
      heroPre: "SOBRE O",
      heroDesc: "O PASS Algarve nasceu para transformar a maneira como turistas vivem o Algarve. Um passaporte digital que conecta você a atrações únicas, benefícios exclusivos e o melhor da região em um só lugar.",
      travelersBold: "+5.630 viajantes",
      travelersRest: "já vivem o melhor do Algarve com mais praticidade e economia.",
      whoLabel: "Quem Somos",
      whoTitle: "Somos apaixonados pelo Algarve e por criar atrações inesquecíveis.",
      whoP1a: "O PASS Algarve é um projeto dedicado a ",
      whoP1b: "valorizar o turismo",
      whoP1c: " da região, conectando visitantes às melhores atrações, parceiros locais e benefícios exclusivos.",
      whoP2: "Trabalhamos todos os dias para oferecer mais praticidade, economia e atrações memoráveis para quem escolhe o Algarve como destino.",
      f1t: "Empresa 100%", f1s: "Portuguesa",
      f2t: "Pagamento Seguro", f2s: "e Confiável",
      f3t: "Suporte Dedicado", f3s: "ao Cliente",
      oneYear: "1 ANO", ofValidity: "de validade",
      stat1: "Parceiros Oficiais", stat2: "Atrações Incríveis", stat3: "Turistas Satisfeitos", stat4: "de história",
      purposeTitle: "Nosso Propósito",
      missionTitle: "MISSÃO",
      missionBody: "Proporcionar acesso fácil, seguro e vantajoso às melhores atrações turísticas do Algarve, promovendo o turismo local e criando memórias inesquecíveis.",
      visionTitle: "VISÃO",
      visionBody: "Ser o passaporte turístico mais reconhecido do Algarve, referência em qualidade, inovação e confiança para viajantes do mundo todo.",
      valuesTitle: "VALORES",
      value1: "Excelência no atendimento",
      value2: "Inovação constante",
      value3: "Valorização dos parceiros locais",
      value4: "Sustentabilidade",
      value5: "Transparência e confiança",
      awardTitle: "Melhor PASS Turístico do Algarve",
      awardSub: "Avaliado por viajantes",
      whyLabel: "Por que escolher o PASS Algarve?",
      whyTitle: "Mais que um passaporte, uma chave para atrações extraordinárias.",
      why1a: "Acesso", why1b: " às melhores atrações e passeios do Algarve",
      why2a: "Benefícios", why2b: " e descontos exclusivos em parceiros selecionados",
      why3a: "Praticidade:", why3b: " tudo em um único QR Code digital",
      why4a: "Economia", why4b: " real em cada atração",
      why5a: "Validade de 1 ano", why5b: " para aproveitar sem pressa",
      ctaTitle: "Pronto para viver o melhor do Algarve?",
      ctaDesc: "Adquira agora o seu PASS e tenha acesso às melhores atrações, passeios e benefícios exclusivos da região.",
      ctaBuy: "Comprar Agora",
      ctaView: "Ver Passaportes",
      mini1t: "COMPRA SEGURA", mini1s: "Seus dados protegidos",
      mini2t: "MELHOR PREÇO GARANTIDO", mini2s: "Garantia o melhor preço",
      mini3t: "SUPORTE DEDICADO", mini3s: "Estamos aqui para ajudar",
      partnersTitle: "Nossos Parceiros Oficiais",
      partnersCta: "Conhecer todos os parceiros"
    },
    cf: {
      home: "Início",
      breadcrumb: "Como funciona",
      label: "Passaporte Algarve",
      title1: "Como ", title2: "funciona",
      subtitle: "Tudo o que você precisa saber para aproveitar o melhor do Algarve com o seu PASS Algarve.",
      subtitle2: "Simples, rápido e seguro.",
      b1t: "Uso flexível", b1s: "Quando quiser",
      b2t: "Economia", b2s: "em atrações",
      b3t: "Seguro", b3s: "e confiável",
      b4t: "Suporte dedicado", b4s: "sempre que precisar",
      stepsLabel: "Em 3 passos simples",
      stepsTitle1: "Seu acesso ao ", stepsTitle2: "melhor do Algarve",
      s1label: "PRIMEIRO PASSO",
      s1t1: "Escolha o seu no ", s1t2: "passalgarve.com",
      s1desc: "Descubra o PASS Algarve perfeito para a sua viagem. Escolha entre diferentes tipos de passaportes e aproveite com total flexibilidade as melhores atrações, experiências e momentos exclusivos no Algarve.",
      s1bullet: "Para adquirir o seu PASS, basta realizar um cadastro rápido e simples.",
      s2label: "SEGUNDO PASSO",
      s2t1: "Pós pagamento receba seu ", s2t2: "QR PASS",
      s2desc: "Após a compra você receberá automaticamente seu QR PASS ALGARVE DIGITAL no seu painel de cliente com o Passaporte Digital e QR code para validação na atração.",
      s2bullet: "O QR Code é único, pessoal e intransferível.",
      s3label: "TERCEIRO PASSO",
      s3t1: "Apresente, validação e entre nas suas ", s3t2: "atrações",
      s3desc: "Quando chegar na atração só apresente o Passaporte Algarve com seu QR code, será autenticado pela atração e será liberado seu acesso muito rápido, simples e seguro.",
      s3bullet: "Todos os parceiros aqui selecionados são as melhores atrações de cada destino, para você explorar o melhor do Algarve em Portugal.",
      advTitle1: "Viva mais experiências, com ", advTitle2: "mais vantagens",
      a1t: "Flexibilidade total", a1d: "Use quando quiser, durante a validade do seu passaporte.",
      a2t: "Acesso às melhores atrações", a2d: "Seleção exclusiva das principais experiências do Algarve.",
      a3t: "Mais economia", a3d: "Aproveite preços especiais e condições exclusivas.",
      a4t: "QR Code digital", a4d: "Prático, rápido e seguro. Tudo no seu celular.",
      a5t: "Segurança e confiança", a5d: "Tecnologia segura e parceiros credenciados.",
      a6t: "Suporte dedicado", a6d: "Atendimento especializado sempre que precisar.",
      ctaTitle1: "Pronto para viver o ", ctaTitle2: "melhor do Algarve?",
      ctaDesc: "Escolha seu PASS e comece agora sua jornada de descobertas.",
      ctaBuy: "Comprar agora",
      bullet1: "Compra 100% segura",
      bullet2: "Acesso imediato ao seu QR PASS",
      bullet3: "Suporte humano sempre que precisar"
    },
    pd: {
      home: "Início",
      passports: "Passaportes",
      defaultDesc: "Acesso às melhores atrações, passeios e benefícios exclusivos do Algarve com validade de 1 ano.",
      reviewsCount: "(320 avaliações)",
      from: "A partir de",
      perPerson: "por pessoa",
      save: "Poupe",
      vsSeparate: "vs comprar separado",
      qtyLabel: "Quantidade",
      total: "Total",
      holderNamesLabel: "Nomes dos titulares (opcional)",
      holderPlaceholder: "Nome da pessoa",
      buyNow: "Comprar Agora",
      processing: "A processar...",
      receiveInstant: "Receba seu PASS imediatamente após a compra",
      securePay: "Pagamento Seguro",
      flexCancel: "Cancelamento Flexível",
      pill1: "1 ANO DE VALIDADE", pill2: "ACESSO IMEDIATO VIA QR CODE", pill3: "ATRAÇÕES PREMIUM", pill4: "PARCEIROS EXCLUSIVOS",
      includedTitle: "Inclui bilhetes:",
      db1: "Acesso às melhores atrações premium do Algarve",
      db2: "Passeios de barco exclusivos",
      db3: "Benefícios exclusivos em parceiros selecionados",
      db4: "Acesso prioritário em atrações",
      db5: "Descontos exclusivos",
      db6: "Suporte premium durante sua viagem",
      db7: "Validade de 1 ano a partir da data da compra",
      hi1: "Passeios de Barco Exclusivos",
      hi2: "Atrações Gastronômicas",
      hi3: "Benefícios e Descontos Exclusivos",
      attrTitle: "Conheça as Atrações",
      viewAll: "Ver Todas as Atrações",
      noAttr: "Nenhuma atração atribuída a este passaporte ainda.",
      attrFallback: "Atração única em Lagos, Algarve.",
      included: "Incluído",
      value: "Valor:",
      sp1: "Acesso Prioritário", sp2: "Parceiros Exclusivos", sp3: "Descontos Especiais", sp4: "Suporte Premium",
      benefitsTitle: "Benefícios Exclusivos",
      be1t: "10% de desconto", be1d: "em restaurantes selecionados",
      be2t: "15% de desconto", be2d: "em lojas e serviços parceiros",
      be3t: "Upgrade gratuito", be3d: "em atrações selecionadas",
      be4t: "Acesso a eventos", be4d: "e promoções exclusivas",
      be5t: "Atendimento prioritário", be5d: "durante sua viagem",
      howTitle: "Como Funciona",
      h1label: "PRIMEIRO",
      h1body: "Escolha o seu PASS no passalgarve.com. Descubra o PASS Algarve perfeito para a sua viagem. Para adquirir o seu PASS, basta realizar um cadastro rápido de cliente.",
      h2label: "SEGUNDO",
      h2body: "Compre e receba o seu QR PASS. Após a compra, você receberá automaticamente o seu QR PASS ALGARVE DIGITAL, diretamente no seu painel de cliente.",
      h3label: "TERCEIRO",
      h3body: "Apresente e aproveite a sua atração! Ao chegar na atração, basta apresentar o seu PASS Algarve com o QR Code. O acesso será autenticado rapidamente pela atração parceira, liberando sua entrada de forma simples, rápida e segura.",
      g1t: "VÁLIDO POR 1 ANO", g1d: "Seu PASS é válido por 1 ano a partir da data da compra. Use quando quiser!",
      g2t: "FLEXIBILIDADE TOTAL", g2d: "Use quando quiser dentro do período de validade.",
      g3t: "SEM TAXAS OCULTAS", g3d: "Sem taxas extras. O preço que você vê é o final.",
      g4t: "CANCELAMENTO FLEXÍVEL", g4d: "Cancele gratuitamente até 7 dias após a compra.",
      testTitle: "O que nossos turistas dizem",
      moreReviews: "Ver mais avaliações",
      tm1: "O PASS Premium superou nossas expectativas! Atrações incríveis e atendimento impecável.", tc1: "Brasil",
      tm2: "A melhor forma de conhecer o Algarve! Economizamos muito e aproveitamos atrações únicas.", tc2: "França",
      tm3: "As atrações premium são realmente diferenciadas. Vale cada centavo!", tc3: "Reino Unido",
      tm4: "Tudo perfeito! Desde a compra até o atendimento durante nossa viagem.", tc4: "Espanha",
      partnersTitle: "Nossos Parceiros Oficiais",
      ctaTitle: "PRONTO PARA VIVER O MELHOR DO ALGARVE?",
      ctaDescA: "Adquira agora seu ",
      ctaDescB: " e tenha acesso às melhores atrações, passeios e benefícios exclusivos do Algarve.",
      otherPassports: "Ver Outros Passaportes",
      notFound: "Passaporte não encontrado.",
      backHome: "← Voltar à home",
      loadError: "Erro ao carregar passaporte",
      checkoutError: "Erro ao iniciar checkout"
    },
    checkoutPage: {
      checking: "Verificando Pagamento",
      checkingDesc: "Aguarde enquanto confirmamos seu pagamento...",
      confirmedTitle: "Pagamento Confirmado!",
      confirmedDesc: "Seu PASS ALGARVE foi criado com sucesso. Acesse seu painel para visualizar seu passaporte digital.",
      viewMyPassport: "Ver Meu Passaporte",
      backHome: "Voltar ao Início",
      errorTitle: "Erro no Pagamento",
      errorDesc: "Houve um problema ao processar seu pagamento. Por favor, tente novamente.",
      tryAgain: "Tentar Novamente",
      cancelledTitle: "Pagamento Cancelado",
      cancelledDesc: "Você cancelou o processo de pagamento. Não se preocupe, nenhuma cobrança foi realizada.",
      paidToast: "Pagamento confirmado! Seu passaporte está pronto.",
      expiredToast: "Sessão de pagamento expirada.",
      checkPanelToast: "Verifique seu painel para confirmar o passaporte."
    },
    authx: {
      back: "Voltar ao início",
      twofaTitle: "Verificação 2FA",
      loginTitle: "Entrar",
      twofaSubtitle: "Insira o código do Google Authenticator",
      loginSubtitle: "Acesse sua conta do PASS ALGARVE",
      codeLabel: "Código de 6 dígitos",
      backupHintA: "Ou insira um ", backupHintB: "código de backup", backupHintC: " (8 caracteres)",
      verifying: "Verificando...", verify: "Verificar", cancel: "Cancelar",
      email: "Email", emailPlaceholder: "seu@email.com",
      password: "Senha",
      loggingIn: "Entrando...", login: "Entrar",
      noAccount: "Não tem uma conta?", createAccount: "Criar conta",
      enter2faToast: "Insira o código de 6 dígitos do seu autenticador",
      welcome: "Bem-vindo",
      loginError: "Erro ao fazer login. Verifique suas credenciais.",
      invalidCode: "Código inválido. Tente novamente.",
      registerTitle: "Criar Conta",
      registerSubtitle: "Junte-se ao PASS ALGARVE e descubra Lagos",
      fullName: "Nome Completo", namePlaceholder: "Seu nome",
      minChars: "Mínimo 6 caracteres",
      confirmPassword: "Confirmar Senha", repeatPassword: "Repita a senha",
      creating: "Criando conta...",
      passwordsMismatch: "As senhas não coincidem",
      passwordMin: "A senha deve ter pelo menos 6 caracteres",
      accountCreated: "Conta criada com sucesso.",
      registerError: "Erro ao criar conta. Tente novamente.",
      haveAccount: "Já tem uma conta?", enter: "Entrar"
    },
    dash2: {
      day: "dia", days: "dias",
      used: "usado",
      code: "Código",
      codeCopied: "Código copiado",
      copyCode: "Copiar código",
      available: "Disponíveis",
      toUse: "para usar",
      alreadyUsed: "Já usadas",
      of: "de",
      validity: "Validade",
      expiredLower: "expirado",
      remaining: "restantes",
      status: "Estado",
      passportFallback: "Passaporte",
      availableAttractions: "Atrações Disponíveis",
      allVisited: "Todas as atrações já foram visitadas!",
      showQr: "Mostre o QR Code na atração",
      availableBadge: "Disponível",
      usedAttractions: "Atrações Já Utilizadas",
      noneUsedYet: "Ainda não utilizou nenhuma atração — comece pela que mais gosta!",
      visitedOn: "Visitado em",
      holder: "Titular"
    }
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      passports: "Passports",
      howItWorks: "How It Works",
      how: "How It Works",
      experiences: "Experiences",
      attractions: "Attractions",
      prices: "Prices",
      partners: "Partners",
      about: "About",
      faq: "FAQ",
      contact: "Contact",
      login: "Login",
      register: "Register",
      dashboard: "My Account",
      logout: "Logout"
    },
    // Hero
    hero: {
      tagline: "Lagos Special Edition",
      titleLine1: "The Passport for the",
      titleLine2: "Best Experiences",
      subtitle: "Discover Lagos like never before. 4 exclusive experiences in one digital passport.",
      buyButton: "Buy Passport",
      viewAttractions: "View Attractions",
      processing: "Processing..."
    },
    // Top Banner
    topBanner: {
      text: "Passport to the Best Attractions in Algarve"
    },
    // How It Works
    howItWorks: {
      label: "Simple and Fast",
      title: "Three steps and done",
      subtitle: "No need to print anything. It all works on your phone.",
      step1Title: "Choose your passport",
      step1Desc: "Compare the three available tiers and select the one that best fits your trip.",
      step2Title: "Get it in your email",
      step2Desc: "After purchase, you'll instantly receive your digital QR Codes by email.",
      step3Title: "Show at the locations",
      step3Desc: "Show the QR Code on your phone at each partner. Simple and fast.",
      startNow: "Start Now"
    },
    // How it works section
    how: {
      step1Title: "Choose your PASS",
      step1Desc: "Select the passport that fits your travel style.",
      step2Title: "Receive your QR Code",
      step2Desc: "After purchase, get your QR Code in your customer area.",
      step3Title: "Live the attractions",
      step3Desc: "Present your QR Code at partners and enjoy the best of the Algarve."
    },
    // Sections
    sections: {
      howItWorks: "How It Works",
      passportTypes: "Passport Types",
      featuredAttractions: "Featured Attractions",
      algarveMap: "Algarve Map",
      officialPartners: "Our Official Partners",
      faq: "Frequently Asked Questions"
    },
    // Categories
    categories: {
      all: "All",
      boat: "Boat Tours",
      gastro: "Gastronomy",
      sunset: "Sunset",
      adventure: "Adventure",
      family: "Family",
      relax: "Relaxation"
    },
    // Offer / Countdown
    offer: {
      limitedTitle: "Limited Offer!",
      limitedDesc: "Get your PASS Algarve now and experience the best of the Algarve.",
      buyNow: "Buy Now",
      days: "Days",
      hours: "Hours",
      minutes: "Min",
      seconds: "Sec",
      joinTravelers: "Join more than",
      travelersSatisfied: "5,630 happy travelers!",
      soonAttractions: "Attractions coming soon",
      noPassports: "No passports currently available."
    },
    // Attractions
    attractions: {
      label: "What's included",
      title: "Attractions | Unforgettable Experiences",
      duration: "Duration",
      highlights: "Highlights",
      viewMore: "View More",
      backToList: "Back",
      operatedBy: "Operated by",
      gallery: "Gallery",
      includedInPassports: "Passports that include this attraction",
      buyPassport: "Buy Passport",
      noPassports: "This attraction is not yet included in any passport.",
      from: "From",
      perPerson: "/ person",
      loading: "Loading attraction...",
      notFound: "Attraction not found",
      includedFree: "Included in PASS"
    },
    // Passports/Pricing
    passports: {
      title: "Algarve Passport",
      subtitle: "Choose the ideal passport for you. Validate on your phone. No queues, no hassle.",
      popular: "Most Popular",
      validity: "Validity of",
      days: "days",
      qrCode: "Digital QR Code",
      support: "24/7 Support",
      includedAttractions: "Included attractions:",
      chooseButton: "Choose",
      perPerson: "/person",
      youSave: "Save",
      bestseller: "Bestseller",
      loading: "Loading passports..."
    },
    // About
    about: {
      label: "PASS Premium",
      title: "Algarve Passport | Portugal",
      description: "Buy in a single purchase the best Algarve attractions. No queues, no individual tickets, no stress — just curated experiences.",
      benefit1: "4 Premium Experiences Included",
      benefit2: "1 Year Validity",
      benefit3: "Digital Passport with QR Code",
      benefit4: "Add to Apple Wallet",
      benefit5: "Priority Access at Attractions",
      benefit6: "24/7 Support (PT/EN)",
      savingsTitle: "Save up to 25% vs buying separately",
      savingsSubtitle: "Pay once and enjoy. No ticket-by-ticket headaches.",
      pillar1Title: "Buy in 60 seconds",
      pillar1Desc: "Secure Stripe checkout. Digital passport delivered to your inbox instantly.",
      pillar2Title: "100% safe & flexible",
      pillar2Desc: "Encrypted payments, fast support, extended validity — use whenever you want.",
      pillar3Title: "Hand-picked experiences",
      pillar3Desc: "We curated the 4 best Lagos attractions — tested, awarded and one-of-a-kind.",
      includesLabel: "What's included",
      cardTitle: "PASS ALGARVE",
      cardSubtitle: "Lagos Special Edition",
      cardRating: "4.9/5 (250+ reviews)",
      perPerson: "/ person",
      buyNow: "Buy Now",
      securePayment: "Secure payment via Stripe",
      statSold: "Passports Sold",
      statRating: "Average Rating",
      statExperiences: "Premium Experiences"
    },
    // Testimonials
    testimonials: {
      label: "Testimonials",
      title: "What Our Customers Say",
      subtitle: "Over 10,000 travelers have discovered the Algarve with our passport.",
      bought: "Bought",
      review1: "We did more in 3 days than in a normal week of vacation. The QR Code worked perfectly at all locations. Totally recommend!",
      review1Location: "Lisbon, Portugal",
      review1Product: "Plus Passport",
      review2: "The QR Code worked everywhere. Zero stress, no queues to buy tickets. The included food experiences were the highlight of the trip.",
      review2Location: "Porto, Portugal",
      review2Product: "Premium Passport",
      review3: "Worth every euro. We got to visit places we wouldn't have known otherwise. Support was excellent when we needed help.",
      review3Location: "Madrid, Spain",
      review3Product: "Essential Passport"
    },
    // FAQ
    faq: {
      label: "Help",
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know about the Algarve Passport.",
      q1: "Does the passport have an expiration date?",
      a1: "Yes, the passport is valid for 1 year from the purchase date. During this period, you can use all included experiences.",
      q2: "Can I use it on more than one day?",
      a2: "Yes! The passport allows you to use the experiences on different days, as long as within the 1-year validity period.",
      q3: "How do I book at restaurants?",
      a3: "For Happy Hour at Bon Vivant, just show the QR Code from your passport. We recommend arriving early during peak season.",
      q4: "Are there discounts for children?",
      a4: "Children up to 3 years old are free. For ages 4-12, check the specific conditions of each experience when booking.",
      q5: "Can I cancel or change?",
      a5: "The passport is non-refundable after purchase, but you can transfer it to another person. Contact support for more information.",
      q6: "Does the QR Code work offline?",
      a6: "We recommend having an internet connection for validation. In case of emergency, take a screenshot of the QR Code before going to the attraction.",
      q7: "What does each passport level include?",
      a7: "The Lagos Special Passport includes 4 experiences: Ponta da Piedade, Benagil Cave, Dolphin Watching, and Happy Hour at Bon Vivant.",
      q8: "How do I contact support?",
      a8: "You can contact us by email at suporte@passaportealgarve.pt or through the chat available on the site. We respond within 24 hours.",
      stillQuestions: "Still have questions?",
      contactUs: "Contact us at"
    },
    // Footer
    footer: {
      description: "Your digital passport to the best experiences in Lagos, Algarve. Discover the best of southern Portugal.",
      tagline: "Your passport to the best Algarve experiences. Valid for 1 year.",
      quickLinks: "Quick Links",
      info: "Information",
      contactUs: "Contact",
      newsletter: "Newsletter",
      newsletterDesc: "Get exclusive offers and Algarve news.",
      emailPlaceholder: "Your best email",
      subscribe: "Subscribe",
      subscribeSuccess: "Subscribed! You'll receive news shortly.",
      whatsappHours: "WhatsApp support\nEvery day: 8am to 10pm",
      builtWith: "Built with",
      inAlgarve: "in the Algarve",
      terms: "Terms and Conditions",
      privacy: "Privacy Policy",
      refund: "Refund Policy",
      cookies: "Cookies",
      contact: "Contact",
      address: "Lagos, Algarve",
      country: "Portugal",
      securePayments: "Secure payments via",
      rights: "All rights reserved.",
      developedBy: "Developed by"
    },
    // Customer Dashboard
    dashboard: {
      title: "My Account",
      welcome: "Welcome",
      hello: "Hello",
      welcomePanel: "Welcome to your PASS ALGARVE dashboard",
      myPassports: "My Passports",
      noPassports: "You haven't purchased any passports yet.",
      noPassportTitle: "You don't have a passport yet",
      noPassportSubtitle: "Get your PASS ALGARVE and start exploring Lagos!",
      buyPassportBtn: "Buy Passport",
      buyNow: "Buy Now",
      purchaseDate: "Purchase Date",
      expiryDate: "Valid until",
      status: "Status",
      active: "Active",
      expired: "Expired",
      holder: "Holder",
      validity: "Validity",
      visits: "Visits",
      tapForQR: "Tap to view QR Code",
      showAtAttraction: "Show this code at the attraction",
      attractionsTitle: "Attractions",
      viewPassport: "View Passport",
      logout: "Logout",
      logoutSuccess: "Session ended successfully",
      home: "Home",
      loadError: "Error loading passports",
      checkoutError: "Error starting checkout"
    },
    // Auth
    auth: {
      loginTitle: "Login",
      loginSubtitle: "Access your account",
      registerTitle: "Create Account",
      registerSubtitle: "Register to buy your passport",
      email: "Email",
      password: "Password",
      name: "Name",
      loginButton: "Login",
      registerButton: "Register",
      noAccount: "Don't have an account?",
      haveAccount: "Already have an account?",
      register: "Register here",
      login: "Login here",
      loginError: "Login error. Please check your credentials.",
      registerError: "Registration error. Please try again."
    },
    // Checkout
    checkout: {
      successTitle: "Payment Successful!",
      successMessage: "Thank you for your purchase. Your passport has been sent to your email.",
      viewPassport: "View Passport",
      cancelTitle: "Payment Cancelled",
      cancelMessage: "Your payment was cancelled. You can try again whenever you want.",
      backHome: "Back to Home"
    },
    // Common
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      processing: "Processing...",
      checkoutError: "Error starting checkout. Please try again."
    },
    landing: {
      heroTitle1: "Explore the Algarve with",
      heroTitle2: "exclusive experiences",
      heroTitle3: "in a single Passport.",
      heroSubtitle: "Access to the best experiences, tours and tourist benefits in the Algarve, valid for 1 year.",
      buyNow: "Buy Now",
      exploreAttractions: "Explore Attractions",
      touristsUse: "travelers already experience the best of the Algarve with more convenience and savings.",
      statPartners: "Official Partners",
      statAttractions: "Amazing Attractions",
      statTourists: "Happy Tourists",
      fromPrice: "From",
      viewAllAttractions: "View all attractions",
      noAttractionsCategory: "No attractions available for this category.",
      attractionFallbackDesc: "A must-see attraction in the Algarve.",
      loadError: "Could not load passports. Please check your connection.",
      tryAgain: "Try again",
      exploreMap: "Explore on the Interactive Map",
      testimonialsTitle: "What our tourists say",
      newsletterSuccess: "Subscribed! Thank you.",
      newsletterInvalid: "Invalid email",
      checkoutError: "Error starting checkout",
      t1: "PASS Algarve made our trip unforgettable! Super practical and amazing experiences.",
      t1c: "United Kingdom",
      t2: "The best Algarve experiences in one place. We saved money and enjoyed so much more!",
      t2c: "France",
      t3: "I recommend it to everyone visiting the Algarve. Excellent service and amazing partners.",
      t3c: "Spain",
      faqQ1: "How long is the PASS Algarve valid for?",
      faqA1: "Each PASS Algarve is valid for a full year from the date of purchase. Use it whenever you want within that period.",
      faqQ2: "How do I receive my QR Code?",
      faqA2: "After payment, you instantly receive your QR Code by email and it's available in your customer dashboard.",
      faqQ3: "Can I cancel my PASS?",
      faqA3: "Yes. Free cancellation up to 7 days after purchase, as long as you haven't used any attraction yet.",
      faqQ4: "How many experiences can I use?",
      faqA4: "It depends on the PASS you choose. Each type includes a set of experiences — all listed in the passport details.",
      faqQ5: "Is the PASS personal and non-transferable?",
      faqA5: "Yes, the PASS is linked to your name. It can be used by you and your registered companions, according to each experience's rules.",
      faqQ6: "Do children get a discount?",
      faqA6: "Yes. Children up to 12 years old get a special discount on all Family passports. Contact us for more details."
    },
    aboutPage: {
      home: "Home",
      breadcrumbAbout: "About PASS Algarve",
      heroPre: "ABOUT",
      heroDesc: "PASS Algarve was born to transform the way tourists experience the Algarve. A digital passport that connects you to unique attractions, exclusive benefits and the best of the region in one place.",
      travelersBold: "+5,630 travelers",
      travelersRest: "already experience the best of the Algarve with more convenience and savings.",
      whoLabel: "Who We Are",
      whoTitle: "We are passionate about the Algarve and about creating unforgettable attractions.",
      whoP1a: "PASS Algarve is a project dedicated to ",
      whoP1b: "promoting tourism",
      whoP1c: " in the region, connecting visitors to the best attractions, local partners and exclusive benefits.",
      whoP2: "We work every day to offer more convenience, savings and memorable attractions to those who choose the Algarve as their destination.",
      f1t: "100% Portuguese", f1s: "Company",
      f2t: "Secure Payment", f2s: "and Reliable",
      f3t: "Dedicated Support", f3s: "for Customers",
      oneYear: "1 YEAR", ofValidity: "of validity",
      stat1: "Official Partners", stat2: "Amazing Attractions", stat3: "Happy Tourists", stat4: "of history",
      purposeTitle: "Our Purpose",
      missionTitle: "MISSION",
      missionBody: "To provide easy, safe and advantageous access to the best tourist attractions in the Algarve, promoting local tourism and creating unforgettable memories.",
      visionTitle: "VISION",
      visionBody: "To be the most recognized tourist passport in the Algarve, a benchmark in quality, innovation and trust for travelers from all over the world.",
      valuesTitle: "VALUES",
      value1: "Excellence in service",
      value2: "Constant innovation",
      value3: "Valuing local partners",
      value4: "Sustainability",
      value5: "Transparency and trust",
      awardTitle: "Best Tourist PASS in the Algarve",
      awardSub: "Rated by travelers",
      whyLabel: "Why choose PASS Algarve?",
      whyTitle: "More than a passport, a key to extraordinary attractions.",
      why1a: "Access", why1b: " to the best attractions and tours in the Algarve",
      why2a: "Benefits", why2b: " and exclusive discounts at selected partners",
      why3a: "Convenience:", why3b: " everything in a single digital QR Code",
      why4a: "Real savings", why4b: " at every attraction",
      why5a: "1-year validity", why5b: " to enjoy at your own pace",
      ctaTitle: "Ready to experience the best of the Algarve?",
      ctaDesc: "Get your PASS now and enjoy access to the best attractions, tours and exclusive benefits in the region.",
      ctaBuy: "Buy Now",
      ctaView: "View Passports",
      mini1t: "SECURE PURCHASE", mini1s: "Your data protected",
      mini2t: "BEST PRICE GUARANTEED", mini2s: "We guarantee the best price",
      mini3t: "DEDICATED SUPPORT", mini3s: "We're here to help",
      partnersTitle: "Our Official Partners",
      partnersCta: "Meet all our partners"
    },
    cf: {
      home: "Home",
      breadcrumb: "How it works",
      label: "Algarve Passport",
      title1: "How it ", title2: "works",
      subtitle: "Everything you need to know to enjoy the best of the Algarve with your PASS Algarve.",
      subtitle2: "Simple, fast and secure.",
      b1t: "Flexible use", b1s: "Whenever you want",
      b2t: "Savings", b2s: "on attractions",
      b3t: "Safe", b3s: "and reliable",
      b4t: "Dedicated support", b4s: "whenever you need it",
      stepsLabel: "In 3 simple steps",
      stepsTitle1: "Your access to the ", stepsTitle2: "best of the Algarve",
      s1label: "FIRST STEP",
      s1t1: "Choose yours at ", s1t2: "passalgarve.com",
      s1desc: "Discover the perfect PASS Algarve for your trip. Choose from different passport types and enjoy the best attractions, experiences and exclusive moments in the Algarve with total flexibility.",
      s1bullet: "To purchase your PASS, just complete a quick and simple registration.",
      s2label: "SECOND STEP",
      s2t1: "After payment, receive your ", s2t2: "QR PASS",
      s2desc: "After purchase, you'll automatically receive your DIGITAL QR PASS ALGARVE in your customer dashboard with the Digital Passport and QR code for validation at the attraction.",
      s2bullet: "The QR Code is unique, personal and non-transferable.",
      s3label: "THIRD STEP",
      s3t1: "Show, validate and enter your ", s3t2: "attractions",
      s3desc: "When you arrive at the attraction, just show your Algarve Passport with your QR code. It will be authenticated by the attraction and your access will be granted quickly, simply and securely.",
      s3bullet: "All the partners selected here are the best attractions in each destination, so you can explore the best of the Algarve in Portugal.",
      advTitle1: "Live more experiences, with ", advTitle2: "more advantages",
      a1t: "Total flexibility", a1d: "Use it whenever you want during your passport's validity.",
      a2t: "Access to the best attractions", a2d: "Exclusive selection of the Algarve's top experiences.",
      a3t: "More savings", a3d: "Enjoy special prices and exclusive conditions.",
      a4t: "Digital QR Code", a4d: "Practical, fast and secure. All on your phone.",
      a5t: "Safety and trust", a5d: "Secure technology and accredited partners.",
      a6t: "Dedicated support", a6d: "Specialized assistance whenever you need it.",
      ctaTitle1: "Ready to experience the ", ctaTitle2: "best of the Algarve?",
      ctaDesc: "Choose your PASS and start your journey of discovery now.",
      ctaBuy: "Buy now",
      bullet1: "100% secure purchase",
      bullet2: "Instant access to your QR PASS",
      bullet3: "Human support whenever you need it"
    },
    pd: {
      home: "Home",
      passports: "Passports",
      defaultDesc: "Access to the best attractions, tours and exclusive benefits in the Algarve, valid for 1 year.",
      reviewsCount: "(320 reviews)",
      from: "From",
      perPerson: "per person",
      save: "Save",
      vsSeparate: "vs buying separately",
      qtyLabel: "Quantity",
      total: "Total",
      holderNamesLabel: "Holder names (optional)",
      holderPlaceholder: "Person's name",
      buyNow: "Buy Now",
      processing: "Processing...",
      receiveInstant: "Receive your PASS immediately after purchase",
      securePay: "Secure Payment",
      flexCancel: "Flexible Cancellation",
      pill1: "1 YEAR VALIDITY", pill2: "INSTANT ACCESS VIA QR CODE", pill3: "PREMIUM ATTRACTIONS", pill4: "EXCLUSIVE PARTNERS",
      includedTitle: "Tickets included:",
      db1: "Access to the best premium attractions in the Algarve",
      db2: "Exclusive boat tours",
      db3: "Exclusive benefits at selected partners",
      db4: "Priority access at attractions",
      db5: "Exclusive discounts",
      db6: "Premium support during your trip",
      db7: "Valid for 1 year from the date of purchase",
      hi1: "Exclusive Boat Tours",
      hi2: "Gastronomic Attractions",
      hi3: "Exclusive Benefits and Discounts",
      attrTitle: "Discover the Attractions",
      viewAll: "View All Attractions",
      noAttr: "No attraction assigned to this passport yet.",
      attrFallback: "A unique attraction in Lagos, Algarve.",
      included: "Included",
      value: "Value:",
      sp1: "Priority Access", sp2: "Exclusive Partners", sp3: "Special Discounts", sp4: "Premium Support",
      benefitsTitle: "Exclusive Benefits",
      be1t: "10% discount", be1d: "at selected restaurants",
      be2t: "15% discount", be2d: "at partner shops and services",
      be3t: "Free upgrade", be3d: "at selected attractions",
      be4t: "Access to events", be4d: "and exclusive promotions",
      be5t: "Priority service", be5d: "during your trip",
      howTitle: "How It Works",
      h1label: "FIRST",
      h1body: "Choose your PASS at passalgarve.com. Discover the perfect PASS Algarve for your trip. To purchase your PASS, just complete a quick customer registration.",
      h2label: "SECOND",
      h2body: "Buy and receive your QR PASS. After purchase, you'll automatically receive your DIGITAL QR PASS ALGARVE directly in your customer dashboard.",
      h3label: "THIRD",
      h3body: "Show it and enjoy your attraction! When you arrive at the attraction, just show your PASS Algarve with the QR Code. Access will be quickly authenticated by the partner attraction, granting your entry simply, quickly and securely.",
      g1t: "VALID FOR 1 YEAR", g1d: "Your PASS is valid for 1 year from the date of purchase. Use it whenever you want!",
      g2t: "TOTAL FLEXIBILITY", g2d: "Use it whenever you want within the validity period.",
      g3t: "NO HIDDEN FEES", g3d: "No extra fees. The price you see is final.",
      g4t: "FLEXIBLE CANCELLATION", g4d: "Cancel for free up to 7 days after purchase.",
      testTitle: "What our tourists say",
      moreReviews: "View more reviews",
      tm1: "The Premium PASS exceeded our expectations! Amazing attractions and impeccable service.", tc1: "Brazil",
      tm2: "The best way to discover the Algarve! We saved a lot and enjoyed unique attractions.", tc2: "France",
      tm3: "The premium attractions are truly outstanding. Worth every penny!", tc3: "United Kingdom",
      tm4: "Everything perfect! From the purchase to the service during our trip.", tc4: "Spain",
      partnersTitle: "Our Official Partners",
      ctaTitle: "READY TO EXPERIENCE THE BEST OF THE ALGARVE?",
      ctaDescA: "Get your ",
      ctaDescB: " now and enjoy access to the best attractions, tours and exclusive benefits in the Algarve.",
      otherPassports: "View Other Passports",
      notFound: "Passport not found.",
      backHome: "← Back to home",
      loadError: "Error loading passport",
      checkoutError: "Error starting checkout"
    },
    checkoutPage: {
      checking: "Verifying Payment",
      checkingDesc: "Please wait while we confirm your payment...",
      confirmedTitle: "Payment Confirmed!",
      confirmedDesc: "Your PASS ALGARVE was created successfully. Access your dashboard to view your digital passport.",
      viewMyPassport: "View My Passport",
      backHome: "Back to Home",
      errorTitle: "Payment Error",
      errorDesc: "There was a problem processing your payment. Please try again.",
      tryAgain: "Try Again",
      cancelledTitle: "Payment Cancelled",
      cancelledDesc: "You cancelled the payment process. Don't worry, no charge was made.",
      paidToast: "Payment confirmed! Your passport is ready.",
      expiredToast: "Payment session expired.",
      checkPanelToast: "Check your dashboard to confirm your passport."
    },
    authx: {
      back: "Back to home",
      twofaTitle: "2FA Verification",
      loginTitle: "Login",
      twofaSubtitle: "Enter the code from Google Authenticator",
      loginSubtitle: "Access your PASS ALGARVE account",
      codeLabel: "6-digit code",
      backupHintA: "Or enter a ", backupHintB: "backup code", backupHintC: " (8 characters)",
      verifying: "Verifying...", verify: "Verify", cancel: "Cancel",
      email: "Email", emailPlaceholder: "your@email.com",
      password: "Password",
      loggingIn: "Logging in...", login: "Login",
      noAccount: "Don't have an account?", createAccount: "Create account",
      enter2faToast: "Enter the 6-digit code from your authenticator",
      welcome: "Welcome",
      loginError: "Login error. Please check your credentials.",
      invalidCode: "Invalid code. Please try again.",
      registerTitle: "Create Account",
      registerSubtitle: "Join PASS ALGARVE and discover Lagos",
      fullName: "Full Name", namePlaceholder: "Your name",
      minChars: "Minimum 6 characters",
      confirmPassword: "Confirm Password", repeatPassword: "Repeat the password",
      creating: "Creating account...",
      passwordsMismatch: "Passwords do not match",
      passwordMin: "Password must be at least 6 characters",
      accountCreated: "Account created successfully.",
      registerError: "Error creating account. Please try again.",
      haveAccount: "Already have an account?", enter: "Login"
    },
    dash2: {
      day: "day", days: "days",
      used: "used",
      code: "Code",
      codeCopied: "Code copied",
      copyCode: "Copy code",
      available: "Available",
      toUse: "to use",
      alreadyUsed: "Already used",
      of: "of",
      validity: "Validity",
      expiredLower: "expired",
      remaining: "remaining",
      status: "Status",
      passportFallback: "Passport",
      availableAttractions: "Available Attractions",
      allVisited: "All attractions have already been visited!",
      showQr: "Show the QR Code at the attraction",
      availableBadge: "Available",
      usedAttractions: "Used Attractions",
      noneUsedYet: "You haven't used any attraction yet — start with your favorite!",
      visitedOn: "Visited on",
      holder: "Holder"
    }
  }
};

const LanguageContext = createContext();

const PUBLIC_PREFIXES = ["/passaporte", "/passport", "/experiencias", "/experiences", "/atracao", "/attraction", "/sobre", "/about", "/como-funciona", "/how-it-works", "/termos", "/terms", "/privacidade", "/privacy", "/cookies", "/cookie-policy"];
const isPublicPath = (p) => p === "/" || PUBLIC_PREFIXES.some((x) => p === x || p.startsWith(x + "/"));
const isEnPath = (p) => p === "/en" || p.startsWith("/en/");

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [language, setLanguage] = useState(() => {
    const p = window.location.pathname;
    if (isEnPath(p)) {
      return 'en';
    }
    if (isPublicPath(p)) {
      return 'pt';
    }
    const saved = localStorage.getItem('language');
    if (saved && (saved === 'pt' || saved === 'en')) {
      return saved;
    }
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang && browserLang.startsWith('pt')) {
      return 'pt';
    }
    return 'en';
  });

  const prevPath = useRef(location.pathname);
  useEffect(() => {
    const p = location.pathname;
    const enUrl = isEnPath(p);
    const pathChanged = prevPath.current !== p;
    prevPath.current = p;
    if (pathChanged && enUrl && language !== 'en') {
      setLanguage('en');
      return;
    }
    const suffix = location.search + location.hash;
    if (language === 'en' && !enUrl && isPublicPath(p)) {
      navigate(('/en' + (p === '/' ? '' : p)) + suffix, { replace: true });
    } else if (language === 'pt' && enUrl) {
      navigate((p.replace(/^\/en/, '') || '/') + suffix, { replace: true });
    }
  }, [language, location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      if (value && value[k] !== undefined) {
        value = value[k];
      } else {
        // Fallback to Portuguese
        let fb = translations['pt'];
        for (const fk of keys) {
          if (fb && fb[fk] !== undefined) {
            fb = fb[fk];
          } else {
            return key;
          }
        }
        return fb;
      }
    }
    return value;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'pt' ? 'en' : 'pt');
  };

  const localizePath = (path) => {
    if (language !== 'en' || !path || !path.startsWith('/')) return path;
    if (path === '/') return '/en';
    if (path.startsWith('/#')) return '/en' + path.slice(1);
    return isPublicPath(path) ? '/en' + path : path;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, localizePath, t, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
